import { render, staticRenderFns } from "./editBusinessOpportunity.vue?vue&type=template&id=2744e0f4&scoped=true"
import script from "./editBusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./editBusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./editBusinessOpportunity.vue?vue&type=style&index=0&id=2744e0f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744e0f4",
  null
  
)

export default component.exports